import React, { useEffect, useState } from "react";
import LayoutSubmaster from "../../components/layoutSubmasterConfig/layoutSubmaster";
import DataTable, { TableColumn } from "react-data-table-component";
import { apiClientSubmaster } from "../../services/setupClientSubmaster/apiClientSubmaster";
import LocalStorage from "../../helpers/localstorage";
import { toast } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

interface TitleDoc {
  id: number;
  textodoc: string;
  submasterId: number;
}

function ConfigEditTextDoc() {
  const localStorage = new LocalStorage();
  const canEditCompany = localStorage.hasWebPermission("canCompanyEdit");
  const [data, setData] = useState<TitleDoc[]>([]);
  const [loading, setLoading] = useState(false);

  const [editingId, setEditingId] = useState<number | null>(null);
  const [editingText, setEditingText] = useState("");

  const handlegetTitleDoc = async () => {
    setLoading(true);
    try {
      const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
      const response = await ApiClient.post(`crud/getdata/titledoc/${localStorage.getId()}/false`);
      setData(response.data);
    } catch (error) {
      toast.error("Erro ao buscar dados do TitleDoc");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateTitleDoc = async (id: number, textUser: string) => {
    setLoading(true);
    try {
      const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
      await ApiClient.post(`crud/updatedata/titledoc/${id}`, {
        textodoc: textUser
      });

      toast.success("Documento atualizado com sucesso!");
      // Fecha o modal manualmente
      const modalEl = document.getElementById("editModal");
      const modal = window.bootstrap?.Modal.getInstance(modalEl!) || new (window as any).bootstrap.Modal(modalEl);
      modal.hide();

      // Atualiza os dados da tabela
      await handlegetTitleDoc();

    } catch (error) {
      toast.error("Erro ao atualizar o documento.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handlegetTitleDoc();
  }, []);

  const handleEdit = (row: TitleDoc) => {
    setEditingId(row.id);
    setEditingText(row.textodoc);
    const modal = new (window as any).bootstrap.Modal(document.getElementById("editModal"));
    modal.show();
  };

  const handleSave = async () => {
    if (editingId !== null) {
      await handleUpdateTitleDoc(editingId, editingText);
    }
  };

  const columns: TableColumn<TitleDoc>[] = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      width: "80px",
    },
    {
      name: "Texto do Documento",
      selector: (row) => row.textodoc,
      wrap: true,
      grow: 2,
    },
    ...(canEditCompany ? [{
      name: "Ações",
      cell: (row) => (
        <button className="btn btn-outline-primary btn-sm" onClick={() => handleEdit(row)}>
          Editar
        </button>
      ),
      width: "120px",
    } as TableColumn<TitleDoc>] : []),
  ];

  return (
    <LayoutSubmaster>
      <div className="content mt-4">
        <h6 className="mb-4">Edição de documento</h6>

        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          dense
          highlightOnHover
          noHeader
        />
      </div>

      {/* Modal Bootstrap puro */}
      <div className="modal fade" id="editModal" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="editModalLabel">Editar Documento</h5>
              <button type="button" className="mr-4 mt-4 btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
            </div>
            <div className="modal-body">
              <textarea
                className="form-control"
                rows={10}
                value={editingText}
                onChange={(e) => setEditingText(e.target.value)}
                placeholder="Edite o texto aqui..."
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="button" className="btn btn-primary" onClick={handleSave}>Salvar</button>
            </div>
          </div>
        </div>
      </div>
    </LayoutSubmaster>
  );
}

export default ConfigEditTextDoc;
